<template>
  <div class="flex h-full justify-center bg-gray-900 pt-1">
    <div class="flex-1 border-t border-gray-600 bg-gray-800">
      <ul class="ml-1 flex-static flex font-hairline text-xs justify-center relative float-right">
        <li class="-mb-px">
          <button @click='position = true' :class="makeClasses(true)">
            <border-outside />
          </button>
        </li>
        <li>
          <button @click='position = false' :class="makeClasses(false)">
            <border-inside />
          </button>
        </li>
      </ul>
      <div class="pbc-transform-property-type-header">{{position ? 'Position' : 'Anchor'}}</div>
      <position label='Position' class="bg-gray-800" v-if='position' v-model='value.pos' @change="onChangePosition" :variables='variables' />
      <position label='Anchor' class="bg-gray-800" v-else v-model='value.anchor' @change="onChangeAnchor" :variables='variables' />
    </div>
  </div>

</template>
<script>
import BorderInside from '@icons/BorderInside.vue';
import BorderOutside from '@icons/BorderOutside.vue';
import ToggleSwitch from '@ui/atoms/ToggleSwitch.vue';
import Position from '@ui/atoms/Position.vue';
export default {
  props:{
    value:{
      type:Object,
      required:true
    },
    variables:{
      type:Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      position:true
    }
  },
  components:{
    Position,
    BorderInside,
    BorderOutside
  },
  methods : { 
    onChangePosition(nv, ov) {
      this.$emit("change-position", nv, ov);
    },
    onChangeAnchor(nv, ov) {
      this.$emit("change-anchor", nv, ov);
    },
    makeClasses(position) {
      const classes = "inline-block border-gray-600 border-l border-t border-b rounded-l py-1 px-1 mb-1 font-semibold".split(" ");
      if (position && this.position) {
        classes.push('text-gray-300');
        classes.push('bg-gray-800');
      } else if (!position && !this.position) {
        classes.push('text-gray-300');
        classes.push('bg-gray-800');
      } else {
        classes.push('text-gray-500');
        classes.push('bg-gray-900');
      }
      return classes;
    }
  }

}
</script>
